<template>
  <div id="app" :class="currentRouteName">
    <div class="cambro-logo" v-if="showLogo"><a href="https://www.cambro.com" target="_blank"><img src="@/assets/images/cambro-logo.png" width="100%" /></a></div>
    <div class="menu-container" :class="{ 'menu-open': isMenuOpen }">
      <button class="hamburger mobile" @click="toggleMenu">
        <span :class="{ 'active': isMenuOpen }"></span>
      </button>

      <!-- <nav>
        <router-link v-if="!isLoggedIn" to="/register" @click.native="closeMenu">Create an Account</router-link>
        <router-link v-if="!isLoggedIn" to="/login" @click.native="closeMenu">Log In</router-link>
        <span v-if="isLoggedIn">Welcome, {{ user?.name }}!</span>
        <router-link v-if="isLoggedIn" to="/start-assessment" @click.native="closeMenu">New Assessment</router-link>
        <router-link v-if="isLoggedIn" to="/dashboard" @click.native="closeMenu">Dashboard</router-link>
        <a v-if="isLoggedIn" href="#" @click.prevent="logout">Logout</a>
        <router-link v-if="isAdmin" to="/admin" @click.native="closeMenu">Admin Dashboard</router-link>
      </nav> -->
      
      <nav>
        <span v-if="isLoggedIn" class="nav-welcome">{{ $t('nav.welcome_firstname').replace(/[\(（]first_name[\)）]/g, user?.name) }}</span>
        <div v-if="showSolutionsMenu" class="solutions-menu">
          <div class="solutions-toggle" @click="toggleSolutions">
            Solutions
            <i class="fas fa-caret-down" :class="{ 'rotate': isSolutionsOpen }"></i>
          </div>
          <div v-if="isSolutionsOpen" class="solutions-submenu">
            <a href="/storesafe/receiving" target="_parent" @click="closeMenu">Receiving</a>
            <a href="/storesafe/storage" target="_parent" @click="closeMenu">Storage</a>
            <a href="/storesafe/preparation" target="_parent" @click="closeMenu">Preparation</a>
            <a href="/storesafe/service" target="_parent" @click="closeMenu">Service</a>
            <a href="/storesafe/warewashing" target="_parent" @click="closeMenu">Warewashing</a>
          </div>
        </div>
        <!-- <router-link v-if="!isLoggedIn" to="/register" @click.native="closeMenu">Create an Account</router-link> -->
        <router-link v-if="!isLoggedIn" to="/login" @click.native="closeMenu">{{ $t('nav.my_account') }}</router-link>
        <router-link v-if="isLoggedIn" to="/start-assessment" @click.native="closeMenu">{{ $t('nav.new_assessment') }}</router-link>
        <router-link v-if="isLoggedIn" to="/dashboard" @click.native="closeMenu">{{ $t('nav.my_dashboard') }}</router-link>
        <router-link v-if="isAdmin" to="/admin" @click.native="closeMenu">Admin Dashboard</router-link>
        <LanguageSwitcher :dark="isDarkBackground" />
        <a href="/storesafe/receiving" target="_parent" @click="closeMenu" class="mobile">Receiving</a>
        <a href="/storesafe/storage" target="_parent" @click="closeMenu" class="mobile">Storage</a>
        <a href="/storesafe/preparation" target="_parent" @click="closeMenu" class="mobile">Preparation</a>
        <a href="/storesafe/service" target="_parent" @click="closeMenu" class="mobile">Service</a>
        <a href="/storesafe/warewashing" target="_parent" @click="closeMenu" class="mobile">Warewashing</a>
        <a v-if="isLoggedIn" href="#" @click.prevent="logout">{{ $t('nav.logout') }}</a>
      </nav>
    </div>
    <router-view @login-success="handleLoginSuccess" @register-success="handleLoginSuccess"/>
  </div>
  <div class="cleaner"></div>
  <Footer />
</template>

<script>
import { auth } from '@/api';
import Footer from './components/Footer.vue';
import LanguageSwitcher from './components/LanguageSwitcher.vue';

export default {
  name: 'App',
  components: {
    Footer,
    LanguageSwitcher
  },
  data() {
    return {
      isMenuOpen: false,
      user: null,
      isSolutionsOpen: false
    };
  },
  async mounted() {
    console.log('🚀 App.vue mounted - initializing...');
    this.initGoogleAnalytics();
    document.addEventListener('click', this.handleClickOutside);

    // Initialize translations
    try {
      console.log('📚 Starting translation initialization...');
      await this.$store.dispatch('translations/fetchAvailableLanguages');
      console.log('✓ Languages fetched');
      await this.$store.dispatch('translations/initializeLanguage');
      console.log('✓ Language initialized');
    } catch (error) {
      console.error('❌ Error initializing translations:', error);
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  computed: {
    showLogo() {
      const staticPages = ['Home', 'Receiving', 'Storage', 'Preparation', 'Service', 'Warewashing', 'AdminDashboard'];
      return !staticPages.includes(this.$route.name);
    },
    isLoggedIn() {
      return !!this.user;
    },
    isAdmin() {
      return this.user?.isAdmin || false;
    },
    currentRouteName() {
      return this.$route.name || '';
    },
    showSolutionsMenu() {
      const staticRoutes = ['Home', 'Receiving', 'Storage', 'Preparation', 'Service', 'Warewashing'];
      return staticRoutes.includes(this.currentRouteName);
    },
    isDarkBackground() {
      const darkRoutes = ['Home', 'Receiving', 'Storage', 'Preparation', 'Service', 'Warewashing'];
      return darkRoutes.includes(this.currentRouteName);
    }
  },
  methods: {
    initGoogleAnalytics() {
      // Create Google Analytics script tag
      const gtagScript = document.createElement('script');
      gtagScript.async = true;
      gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=UA-11511238-1';
      document.head.appendChild(gtagScript);
      
      // Create and add the gtag configuration script
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      gtag('js', new Date());
      gtag('config', 'UA-11511238-1');
      
      // Attach to window for global access
      window.gtag = gtag;
    },
    closeMenu() {
      this.isMenuOpen = false;
      this.isSolutionsOpen = false;
    },
    toggleSolutions() {
      this.isSolutionsOpen = !this.isSolutionsOpen;
    },
    handleClickOutside(event) {
      const menu = document.querySelector('.solutions-menu');
      if (menu && !menu.contains(event.target) && this.isSolutionsOpen) {
        this.isSolutionsOpen = false;
      }
    },
    async checkAuth() {
      try {
        const { isAuthenticated, user } = await auth.checkAuth();
        
        if (isAuthenticated && user) {
          // Create a complete user object with fallbacks for missing fields
          const completeUser = {
            id: user.id,
            name: user.name || user.username || user.email?.split('@')[0] || 'User',
            email: user.email || '',
            isAdmin: user.isAdmin || false,
            isRep: user.isRep || false
          };
          
          this.user = completeUser;
          
          // Save to localStorage
          localStorage.setItem('user', JSON.stringify(completeUser));
          
          // Update Vuex store
          this.$store.commit('auth/setUser', completeUser);
          
          console.log('User authenticated and saved:', completeUser);
        } else {
          this.user = null;
          localStorage.removeItem('user');
          this.$store.commit('auth/clearUser');
        }
      } catch (error) {
        console.error('Auth check failed:', error);
        this.user = null;
        localStorage.removeItem('user');
        this.$store.commit('auth/clearUser');
      }
    },
    handleLoginSuccess(user) {
      console.log('Login/Register success:', user);
      if (!user.name) {
        user.name = user.username || user.email || user.full_name || 'User';
      }
      this.user = user;
      localStorage.setItem('user', JSON.stringify(user));
      this.$store.commit('auth/setUser', user);
    },
    debugUserObject() {
      console.log('Current user object:', this.user);
      const savedUser = localStorage.getItem('user');
      console.log('Saved user from localStorage:', savedUser ? JSON.parse(savedUser) : null);
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
    checkUserData() {
      console.log('User data:', this.user);
      console.log('Is logged in:', this.isLoggedIn);
    },
    async logout() {
      try {
        await auth.logout();
        this.user = null;
        this.isMenuOpen = false;
        this.$router.push('/login');
      } catch (error) {
        console.error('Logout failed:', error);
      }
    }
  },
  created() {
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      try {
        const parsedUser = JSON.parse(savedUser);
        this.user = parsedUser;
        console.log('Loaded user from localStorage:', this.user);
      } catch (e) {
        console.error('Error parsing saved user:', e);
      }
    }
    
    this.checkAuth();
  }
};
</script>